'use client'

import Logotype from '@/public/logotype.svg'
import Subtitle from '@/public/subtitle.svg'
import CloudLeft from '@/public/cloud-left.svg'
import CloudRight from '@/public/cloud-right.svg'
import CloudRight2 from '@/public/cloud-right2.svg'
import MiniAirplane from '@/public/mini-airplane.svg'
import Signage from '@/public/signage.svg'
import Car from '@/public/car.svg'
// import Link from 'next/link'
import Airplane from '@/public/airplane.svg'
import Building from '@/public/building.svg'
import Ring from '@/public/ring.svg'
import ChevronsDown from '@/public/chevrons-down.svg'
import { ParallaxProvider, Parallax } from 'react-scroll-parallax';
import Link from 'next/link'
import clsx from 'clsx'

export default function Header({ mode = '', ...props }: any) {
    return (
        <header className='rel overflow:hidden bg:primary'>
            <ParallaxProvider>
                <Parallax className={clsx('abs flex inset:0 size:full|100svh align-items:center blend:screen justify-content:center max-h:100%')} disabled={mode !== 'hero'} speed={0} opacity={[10, -6]} scale={[-6, 10]} translateY={[-50, 50]}>
                    <video autoPlay muted loop playsInline className={clsx('@fade|3s object:cover', mode === 'hero' ? 'size:50%' : 'size:full')}>
                        <source src="/globe.webm" type="video/webm" />
                    </video>
                </Parallax>
                <Parallax disabled={mode !== 'hero'} speed={0} opacity={[0, 4]} translateY={[-25, 25]} className={clsx('flex align-items:center justify-content:center', {
                    'size:full|100svh': mode === 'hero',
                })}>
                    <div className='flex gap:6x p:12x mx:auto align-items:center flex:col justify-content:center max-w:660 w:full my:20x@sm'>
                        <Logotype className="filter:drop-shadow(0|4|6|black/.3) w:full" title="我的青航時代" />
                        <Subtitle className="w:85%" title="2025 航發會暑期航空營" />
                        <div className='gap:3x grid-cols:2 mt:3x grid-cols:4@sm'>
                            <Link href="/" className='btn btn-lg btn-primary'>活動資訊</Link>
                            <Link href="/news" className='btn btn-lg btn-primary'>相關報導</Link>
                            <Link href="/records" className='btn btn-lg btn-primary'>活動紀錄</Link>
                            <Link href="/history" className='btn btn-lg btn-primary'>歷年活動</Link>
                        </div>
                        {mode === 'hero' && <ChevronsDown className="@flash|3s|infinite size:32 mb:-32 stroke:1 stroke:white" />}
                    </div>
                </Parallax>
                <Parallax className="flex rel align-items:center w:full" disabled={mode !== 'hero'} speed={0} opacity={[-1, 4]} >
                    {props.children && <>
                        <Parallax className="abs center top" opacity={[1, 0]}>
                            <Ring className="w:full" />
                        </Parallax>
                        <Parallax className="abs right top hidden@<xs" speed={10} translateX={[300, 0]}>
                            <MiniAirplane className="@float|3s|infinite w:30vw" />
                        </Parallax>
                        <Parallax className="abs right top hidden@<xs" speed={-10} translateX={[200, -200]}>
                            <MiniAirplane className="@float|3s|infinite w:30vw" />
                        </Parallax>
                        <Parallax className="abs right top hidden@<xs" speed={-20} translateX={[100, -400]}>
                            <MiniAirplane className="@float|3s|infinite w:30vw" />
                        </Parallax>
                        <Parallax className="abs bottom:1/6 left:1/20" translateX={[0, 50]}>
                            <CloudLeft className="@float|3s|infinite w:20vw" />
                        </Parallax>
                        <Parallax className="abs right:-12x top:1/5" translateX={[100, -100]}>
                            <CloudRight className="@float|3s|infinite w:30vw" />
                        </Parallax>
                        <Parallax className="abs right top:2/5" translateX={[120, -100]}>
                            <CloudRight2 className="@float|6s|infinite w:30vw" />
                        </Parallax>
                    </>}
                    {props.children}
                </Parallax>
                <div className={clsx('w:full', {
                    'abs bottom': props.children
                })}>
                    <Parallax speed={0} opacity={[0, 2]} className="rel left:1/20 w:16vw w:30vw@<xs" >
                        <Signage className="w:full" />
                    </Parallax>
                    <Parallax speed={0} opacity={[0, 2]} className="abs bottom right:-5x w:40vw w:60vw@<xs" >
                        <Building className="w:full" />
                    </Parallax>
                    <Parallax speed={0} opacity={[0, 2]} translateX={[-100, 0]} className="abs bottom left:1/3 w:4vw w:10vw@<xs">
                        <Car className="w:full" />
                    </Parallax>
                    <Parallax speed={0} translateX={[-100, 0]} className="abs bottom right:1/6 w:30vw w:50vw@<xs">
                        <Airplane className="w:full" />
                    </Parallax>
                    <div className='bg:green h:8 w:full'></div>
                    <div className='bg:gray h:20 w:full'></div>
                </div>
            </ParallaxProvider>
        </header>
    )
}